import { Navigate, useLocation } from 'react-router-dom';

/** Rewrites /:tenantSlug/dashboard/... to /:tenantSlug/home/..., keeping query and hash. */
export const LegacyDashboardRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^(\/[^/]+)\/dashboard(?=\/|$)/,
    '$1/home'
  );

  return (
    <Navigate to={`${pathname}${location.search}${location.hash}`} replace />
  );
};
